import { render, staticRenderFns } from "./tilburg.vue?vue&type=template&id=277293c1"
import script from "./tilburg.vue?vue&type=script&lang=js"
export * from "./tilburg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports